// extracted by mini-css-extract-plugin
export default {"ScrollWrapper":"Content_ScrollWrapper__PI4bL"};